var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('color-picker-container',{staticClass:"background-color-box-tool-desktop",on:{"save":_vm.saveColor,"input":_vm.changeColor}})}
var staticRenderFns = []

export { render, staticRenderFns }